module.exports = __webpack_public_path__ + "2b4e33fa48f74be577ed0e43de757045.jpg";